export function formatPrice(price, currency = 'SEK') {
    const numberFormatter = new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return `${numberFormatter.format(price)} <small>${currency}</small>`;
  }